import React, {useState} from "react";
import './SendQuestion.css';
import SendQuestion01 from "../../../../static/img/SendQuestion.svg";
import IconsSiteFxBTC41 from "../../../../static/img/SVG/IconsSiteFxBTC412.svg";
import SendQuestion02 from "../../../../static/img/SVG/SendQuestion02.svg";
import EmailSend from "../../../../static/img/SVG/SendQuestion.svg";
import axios from "axios";
const PRERENDER_TEXTS = require("../../../../../prerender_base.js");
let reg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{1,4})$/;

function SendQuestion(props) {
    function TextSource(info) {try {return <>{JSON.parse(PRERENDER_TEXTS['SendQuestion'][info.ArrIndex])[props.lang] ? JSON.parse(PRERENDER_TEXTS['SendQuestion'][info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    const [VisibleSendQuestion, setVisibleSendQuestion] = useState('SendQuestionNo');
    const [eMailValue, seteMailValue] = useState('');
    const [TextValue, setTextValue] = useState('');
    const [eMailErrorVisible, seteMailErrorVisible] = useState("isNoVisible");
    const [TextErrorVisible, setTextErrorVisible] = useState("isNoVisible");
    const [SendQuestionMainBottomMainInVisible, setSendQuestionMainBottomMainInVisible] = useState("isVisible");
    const [SendQuestionMainBottomSuccessVisible, setSendQuestionMainBottomSuccessVisible] = useState('isNoVisible');

    function handleMailChange(event) {
        seteMailValue(event.target.value);
        if(reg.test(eMailValue) === true)  {seteMailErrorVisible("isNoVisible");
            event.preventDefault();
        }
    }

    function ChangeSendQuestionVisible(VisibleSendQuestion) {setVisibleSendQuestion(VisibleSendQuestion);}

    function handleSubmit(e) {
        if(reg.test(eMailValue) === false)  {
            seteMailErrorVisible("isVisible");
            e.preventDefault();
        }
        else {
            seteMailErrorVisible("isNoVisible");
        }
        if(TextValue === '')  {
            setTextErrorVisible("isVisible");
            e.preventDefault();
        }
        if (reg.test(eMailValue) && (TextValue !== '')) {
            //console.log('eMailValue', eMailValue);
            //console.log('TextValue', TextValue);
            e.preventDefault();
            let SubjectMail = 'FeedBack from FXBitcoinforex!';
            let output = TextValue + eMailValue;

            let data = {
                SubjectMail,
                output
            };
            //console.log('data', data);
            // console.log('SubjectMail',SubjectMail);
            // console.log('output',output);
            axios
                .post('https://myadmin.fxbitcoin.org/send', data)
                .then(() => {
                        //console.log('Mail Created');
                        setSendQuestionMainBottomMainInVisible("isNoVisible");
                        setSendQuestionMainBottomSuccessVisible('isVisible');
                    }
                )
                .catch(e => console.log(e));
        }
    }

        return (
            <div className="SendQuestionOutOut">
                <div className={"for_cab " + VisibleSendQuestion} role = "button" tabIndex={0} onKeyPress={() => {}}  onClick={() => ChangeSendQuestionVisible('SendQuestionNo')}> </div>
                <div className={"SendQuestionOut " + VisibleSendQuestion} >
                    <div className="SendQuestionMain">
                        <div className="SendQuestionMainTop">
                            <div className="SendQuestionMainTopText"><TextSource ArrIndex= 'SendQuestion0020'>Задать вопрос специалистам</TextSource></div>
                            <div className="SendQuestionMainTopIMG" role="button" tabIndex={0} onKeyPress={() => {}} onClick={() => ChangeSendQuestionVisible('SendQuestionNo')}><img alt='alt' src={IconsSiteFxBTC41} width='17px' height='17px'/></div>
                        </div>
                        <div className="SendQuestionMainBottom">
                                    <div className={"SendQuestionMainBottomMainIn " + SendQuestionMainBottomMainInVisible}>
                                        <form  onSubmit={handleSubmit}>
                                            <label htmlFor="email" className="SendQuestionMainBottomMainInLabel"><TextSource ArrIndex= 'SendQuestion0025'>Ваша электронная почта</TextSource></label>
                                            <div className={'EmailOutFlex'} >
                                                <input type="text" placeholder='Your Mail' name="eMailValue" value={eMailValue} onChange={handleMailChange} />
                                                <div className='EmailOutFlexIMG' ><img alt='alt' src={EmailSend} width='65px' height='28px'/></div>
                                                <div className='EmailOutFlexText'>
                                                    <TextSource ArrIndex= 'SendQuestion0030'>Ответ придет</TextSource><br/>
                                                    <TextSource ArrIndex= 'SendQuestion0035'>на эту почту</TextSource>
                                                </div>
                                            </div>
                                            <div className={'SendQuestionMainBottomError '+ eMailErrorVisible} ><TextSource ArrIndex= 'SendQuestion0010'>Problem with E-mail</TextSource></div>
                                            <label htmlFor="yourtext" className="SendQuestionMainBottomMainInLabel">
                                                <TextSource ArrIndex= 'SendQuestion0040'>Ваше сообщение:</TextSource></label>
                                            <textarea name="TextValue" placeholder='Your Message'  rows="10" value={TextValue} onChange={(event) => setTextValue(event.target.value)} />
                                            <div className={'SendQuestionMainBottomError '+ TextErrorVisible}><TextSource ArrIndex= 'SendQuestion0015'>Problem</TextSource></div>
                                            <label htmlFor="none"><div> </div></label>
                                            <div className="StandartButtonOut CompanyContactPlace03">
                                                <input type="submit" value={PRERENDER_TEXTS["SendQuestion"] ? PRERENDER_TEXTS["SendQuestion"]['SendQuestion0045'] : '*Отправить'} className='ButtonBlue'/>
                                            </div>
                                        </form>
                                    </div>
                                    <div className={"SendQuestionMainBottomSuccess " + SendQuestionMainBottomSuccessVisible}>
                                        <img alt='Ifyoudontseeimages' src={SendQuestion02} width="128px" height="128px"/>
                                        <div className="SendQuestionMainBottomSuccessText">
                                            <TextSource ArrIndex= 'SendQuestion0050'>Ваше сообщение будет рассмотрено нашими специалистами в ближайшее время. Ответ придет вам на электронную почту</TextSource>
                                        </div>
                                        <div className="StandartButtonOut CompanyContactPlace03">
                                        <div className='ButtonWhiteBlack'  onClick={() => ChangeSendQuestionVisible('SendQuestionNo')} role="button" tabIndex={0} onKeyPress={() => {}}>
                                            <TextSource ArrIndex= 'SendQuestion0055'>Закрыть</TextSource></div>
                                    </div>
                                    </div>


                        </div>
                    </div>
                </div>

                <div className="SendQuestionInfo"  onClick={() => ChangeSendQuestionVisible('SendQuestionYes')} role="button" tabIndex={0} onKeyPress={() => {}}>
                    <TextSource ArrIndex= 'SendQuestion0060'>Нужна помощь?</TextSource><img alt='alt' src={SendQuestion01} width='19px' height='19px'/>
                </div>
            </div>
        )}

export default SendQuestion